import styled from '@emotion/styled';

export const IconWrapper = styled.div`
  width: 28px;
  height: 28px;
`;
